import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { ToastService } from 'src/app/shared/services/toast.service';
import { AuthService } from '../../services/auth.service';
import { isKeycloakMode, KeycloakAuthService } from '../../services/keycloak-auth.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  loginForm: UntypedFormGroup;
  readonly keycloak = isKeycloakMode();

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly authService: AuthService,
    private readonly toastService: ToastService,
    private readonly keycloakAuth: KeycloakAuthService,
    private readonly activatedRoute: ActivatedRoute
  ) {
    this.loginForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required, Validators.minLength(6)]]
    });
  }

  ngOnInit(): void {
    // Vindo de um guard (sessão ausente ou expirada): segue direto ao Keycloak, que volta para a página.
    const returnUrl = this.activatedRoute.snapshot.queryParamMap.get('returnUrl');
    if (this.keycloak && returnUrl) {
      this.entrarPeloKeycloak(returnUrl);
    }
  }

  entrarPeloKeycloak(returnUrl?: string): void {
    this.keycloakAuth
      .login(returnUrl)
      .catch(() => this.toastService.toast('Não foi possível abrir o login. Tente novamente.', EMessageType.Error));
  }

  login(): void {
    const { email, password } = this.loginForm.getRawValue();

    if (!email) {
      this.toastService.toast('Campo e-mail é obrigatório.', EMessageType.Error);
      return;
    }

    if (!password) {
      this.toastService.toast('Campo senha é obrigatório.', EMessageType.Error);
      return;
    }

    this.authService.login(email, password);
  }
}
